import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App";
import "./index.css";
import { BRAND_TITLE } from "./lib/brand";
import { RuntimeModeProvider } from "./lib/runtime";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

document.title = BRAND_TITLE;

// The venue-box image (local/Dockerfile) builds the SPA without
// VITE_CLERK_PUBLISHABLE_KEY — ClerkProvider throws on a missing key, so a
// key-less build mounts no Clerk at all. lib/auth.tsx stubs the Clerk hooks
// to match; the device-pairing gate handles auth in that runtime.
const root = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* RuntimeModeProvider outside ClerkProvider: mode detection is independent of auth. */}
    <RuntimeModeProvider>
      {PUBLISHABLE_KEY ? (
        <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
          {root}
        </ClerkProvider>
      ) : (
        root
      )}
    </RuntimeModeProvider>
  </React.StrictMode>
);
